import { menuItems } from '../components/layouts/Nav/routes';
import { useBadgesQuery } from '../services/utility';
import { useUserAccessRightsQuery } from '../services/user';
import { NavItemProps } from '../components/layouts/Nav/NavItem/NavItem';

export const useNavigationItems = () => {
  const { data: badges } = useBadgesQuery();
  const { data: access } = useUserAccessRightsQuery();

  const getFormattedRights = (access: any[] = []) =>
    access.map(item => ({
      ...item,
      route: item.route.split('/')[1],
    }));

  const formatMenuItemsWithBadges = (items: typeof menuItems, badges: any) =>
    items.map(({ badgeId, link, ...rest }) => {
      const badgeData = badgeId ? badges?.[badgeId as keyof typeof badges] : undefined;
      const updatedLink = `${link}?domain=${encodeURIComponent(badgeData?.domain || '')}`;
      return {
        ...rest,
        link,
        linkWithDomain: updatedLink,
        ...(badgeData ?? {}),
      };
    });

  const filterMenuItemsByAccess = (items: any[], rights: any[]) =>
    items.filter(menuItem => {
      const matchedRight = rights.find(right => menuItem.link.includes(right.route));
      return !matchedRight || matchedRight.read || matchedRight.read_write;
    });

  const findAccessRights = (route: string) => {
    return access?.find(item => item.route.includes(route));
  };

  const findAllAccessRightsByRoute = (route: string) => {
    return access?.filter(item => item.route.includes(route));
  };

  const formattedRights = getFormattedRights(access);
  const menuItemsWithBadges = formatMenuItemsWithBadges(menuItems, badges);
  const baseNavigationMenuItems: NavItemProps[] = filterMenuItemsByAccess(menuItemsWithBadges, formattedRights);

  const navigationMenuItems = baseNavigationMenuItems.map(item => {
    // if (item.label?.toLowerCase().includes('outbound')) {
    //   return {
    //     ...item,
    //     count: saleOrders?.items?.length ?? 0,
    //   };
    // }
    return item;
  });

  return { navigationMenuItems, access, findAccessRights, findAllAccessRightsByRoute };
};
